import FileUploadIndicator from './FileUploadIndicator';

export default FileUploadIndicator;
